import { pushPurchaseEvent } from "@/helpers/gtm/useGTMPurchase.ts";
import { URLParam } from "@/helpers/interfaces/URLParam.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { AppPage } from "@/stores/EngineStore/enums/AppPage.ts";
import { PaymentResultType } from "@/stores/EngineStore/enums/PaymentResultType.ts";
import { useLayoutEffect } from "react";
import { useShallow } from "zustand/react/shallow";

export const usePaymentResultURLParam = () => {
  const { setPaymentResult, page, setPage, resetAll, setPendingPurchase } = useEngineStore(
    useShallow((state) => ({
      setPaymentResult: state.setPaymentResult,
      page: state.page,
      setPage: state.setPage,
      resetAll: state.resetAll,
      setPendingPurchase: state.setPendingPurchase,
    })),
  );

  // useLayoutEffect for better recognition
  useLayoutEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const paymentResultType = urlParams.get(URLParam.PaymentResult) as PaymentResultType | null;

    if (!paymentResultType) {
      if (page === AppPage.PaymentResult) setPage(AppPage.AccommodationPicking);
      return;
    }

    // Resolve the conversion deferred at submit, now that the payment outcome is known.
    const pendingPurchase = useEngineStore.getState().pendingPurchase;

    if (paymentResultType === PaymentResultType.Success) {
      // Paid → fire the conversion once.
      if (pendingPurchase) pushPurchaseEvent(pendingPurchase);
      setPendingPurchase(undefined);

      resetAll(true);
      setPaymentResult(paymentResultType);
    } else {
      // Failed/cancelled → drop it, keep cart for retry.
      if (pendingPurchase) setPendingPurchase(undefined);
      urlParams.delete(URLParam.PaymentResult);
      history.replaceState(null, "", `${window.location.pathname}?${urlParams.toString()}`);
      setPage(AppPage.ReservationOverview);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.search]);
};
